import { render, staticRenderFns } from "./CmsUrlWrapper.vue?vue&type=template&id=01a6d33a&"
import script from "./CmsUrlWrapper.vue?vue&type=script&lang=ts&"
export * from "./CmsUrlWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports